import { JSX } from 'preact'
import { useMemo } from 'preact/hooks'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useComponentStyle } from '../Style'
import { previewProps } from '../../preview'

interface Attributes {
  [key: string]: unknown
}

function parseAttributes(attrs: NamedNodeMap): Attributes {
  return [...(attrs || [])].reduce<Attributes>((res, attr) => {
    const name = attr.name === 'class' ? 'className' : attr.name
    res[name] = attr.value
    return res
  }, {})
}

function parseSvgString(svgString: string): { html: string; props: Attributes } {
  const parser = new DOMParser()
  const doc = parser.parseFromString(svgString, 'text/html')
  const svg = doc.querySelector('svg')
  return {
    html: svg?.innerHTML || '',
    props: parseAttributes(svg?.attributes),
  }
}

export const Icon = ({ src, ...rest }: TBlockProps<BlockType.Icon>): JSX.Element => {
  const { classes } = useComponentStyle('icon', rest)
  const { html, props } = useMemo(() => parseSvgString(src), [src])

  return html ? (
    <svg
      {...props}
      className={classnames(classes)}
      dangerouslySetInnerHTML={{ __html: html }}
      {...(rest.id ? previewProps(BlockType.Icon, rest.id) : {})}
    />
  ) : null
}
